
import { WHATSAPP_SUPPORT_PHONE } from 'constants/global';
import React from 'react';
import { Col, Container, Row } from 'reactstrap';

const FooterPublic = () => {
    return (
        <React.Fragment>
            <footer className="footer footer-public d-none d-lg-block">
                <Container fluid>
                    <Row>
                        <Col>
                            {new Date().getFullYear()} © Influns.
                        </Col>
                        <Col>
                            <ul className="d-flex list-unstyled m-0 justify-content-end ">
                                <li className="menu-item">
                                    <a href="https://influns.com" target="_blank" className="menu-link px-2">About</a>
                                </li>
                                <li className="menu-item">
                                    <a href={`https://api.whatsapp.com/send?phone=${WHATSAPP_SUPPORT_PHONE}&text=Hi, I need help.`} target="_blank" className="menu-link px-2">Support</a>
                                </li>
                                <li className="menu-item">
                                    <a href="https://influns.com/legal/terms.html" target="_blank" className="menu-link px-2">Terms</a>
                                </li>
                            </ul>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </React.Fragment>
    );
};

export default FooterPublic;